import {useMemo} from "react";

import {Post, TreeNode} from "../../../types/Post";
import {filterContentPosts} from "../model";

type UseContentListViewProps = {
  posts: Post[];
  selectedCategory: TreeNode | null;
};

export const useContentListView = ({posts, selectedCategory}: UseContentListViewProps) => {
  const filteredPosts = useMemo(() => {
    return filterContentPosts({posts, selectedCategory});
  }, [posts, selectedCategory]);

  return {
    filteredPosts,
  };
};
